module.exports = __webpack_public_path__ + "assets/pdf/I03-en-air-quality.5337d7e7.pdf";